import { useEffect, useRef, useState } from 'react'

import { useNavigate } from '@tanstack/react-router'

import { useSidebar } from '@/components/sui/sidebar'

import { useAccessState } from '../../../access/hooks/use-access-state'
import {
  trackNoPlanBannerClicked,
  trackNoPlanBannerViewed,
} from '../../no-plan-banner.tracking'
import { NoPlanBanner } from '../no-plan-banner'

export function NoPlanBannerWrapper() {
  const navigate = useNavigate()
  const { state, isMobile, setOpenMobile } = useSidebar()
  const hasTrackedView = useRef(false)
  const [bannerVisible, setBannerVisible] = useState(false)

  const { accessState, planFeature } = useAccessState()

  const shouldRender = accessState === 'no-plan'

  useEffect(() => {
    if (!shouldRender || hasTrackedView.current) return
    hasTrackedView.current = true
    trackNoPlanBannerViewed({ source: 'sidebar', planFeature })
  }, [shouldRender, planFeature])

  useEffect(() => {
    if (!shouldRender || (!isMobile && state !== 'expanded')) {
      setBannerVisible(false)
      return
    }
    const timer = setTimeout(() => setBannerVisible(true), 300)
    return () => clearTimeout(timer)
  }, [shouldRender, state, isMobile])

  if (!shouldRender) return null

  const handleClick = () => {
    trackNoPlanBannerClicked({ source: 'sidebar', planFeature })
    // The sheet does not close on navigation, so the banner that navigates
    // has to close it — the same thing every entry in `nav-main` does.
    setOpenMobile(false)
    void navigate({ to: '/settings/billing/plans' })
  }

  return (
    <>
      {/* Expanded version */}
      <div className="px-1 group-data-[collapsible=icon]:hidden">
        <div
          className={`transition-all duration-300 ${
            bannerVisible
              ? 'translate-y-0 opacity-100'
              : 'translate-y-2 opacity-0'
          }`}
        >
          <NoPlanBanner onCtaClick={handleClick} />
        </div>
      </div>
      {/* Collapsed version (icon only) */}
      <div className="hidden group-data-[collapsible=icon]:block">
        <NoPlanBanner collapsed onCtaClick={handleClick} />
      </div>
    </>
  )
}
